import { Component, Input } from '@angular/core';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { GlobalConstants } from 'src/app/services/global-constants';

@Component({
  selector: '[app-list-ous]',
  templateUrl: './list-ous.component.html',
  styleUrls: ['./list-ous.component.scss']
})
export class ListOusComponent {
checkisImg(arg0: string|undefined): any {
  if(arg0) {
    return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
  } else {
    return false
  }  
}
  @Input() data: OrganizationUnit | undefined;


  staticURL = GlobalConstants.staticFilesURL;
  
  isIcon = false;

  ngOnInit() {
    console.log(this.data?.image)
  }
}
